// test58
(58 && 0);
